module.exports = __webpack_public_path__ + "img/skrill.087af872.svg";